import apollo from '@/graphql'

import StoresQuery from '@/graphql/store/StoresQuery.gql'

// initial state
const state = {
  searchTerm: '',
  stores: [],
  storeListLoading: false,
}

// getters
const getters = {
  stores: st => st.stores,
  storeListLoading: st => st.storeListLoading,
}

const mutations = {
  setStores(st, stores) {
    state.stores = stores
  },

  setStoreListSearchTerm(state, term) {
    state.searchTerm = term
  },

  setStoreListLoading(state, loading) {
    state.storeListLoading = loading
  },
}

// actions
const actions = {
  async loadStores({ commit }, { isCampaignCreationFilter, storeAreasId }) {
    commit('setStoreListLoading', true)
    const { data: { stores } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: StoresQuery,
        variables: {
          companiesId:
            this.getters['Auth/user'].companiesId === 1
              ? null
              : this.getters['Auth/user'].companiesId,
          isCampaignCreationFilter: isCampaignCreationFilter || false,
          storeAreasId,
        },
      })

    commit('setStores', stores)
    commit('setStoreListLoading', false)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/store/StoreList.js